/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/button-has-type */
import { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';


interface StrapiImage {
  url: string;
}

interface StrapiButton {
  Name: string;
  URL: string;
  id: string;
}

interface StrapiPopAvdNode {
  AdsImage: StrapiImage;
  Button: StrapiButton;
  Descrption: string;
  Heading: string;
  isShowAds: boolean;
}

export interface StrapiPopAvdData {
  nodes?: StrapiPopAvdNode[] | null;
}

//// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function PopupAds({ nodes }: StrapiPopAvdData) {
  // Receive data from GraphQL query
  const [isOpen, setIsOpen] = useState(false);
  const [isProductSectionVisible, setIsProductSectionVisible] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null)
  const productSectionRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    // Observe when the product section comes into view
    productSectionRef.current = document.getElementById("optionCategory");

    if (!productSectionRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsProductSectionVisible(true);
          observer.disconnect(); // Stop observing once it's visible
        }
      },
      { threshold: 0.5 } // Adjust threshold as needed
    );

    observer.observe(productSectionRef.current);

    return () => { observer.disconnect(); };
  }, []);

  useEffect(() => {
    if (!isProductSectionVisible) return;

    // Set a timer to open the popup after 20 seconds
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 10000);

    return () => { clearTimeout(timer); };
  }, [isProductSectionVisible]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isOpen])

  // Check if nodes is undefined or empty
  if (!isOpen || !nodes || nodes.length === 0) return null;

  const { AdsImage, Button, Descrption, Heading, isShowAds } = nodes[0];

  

  if (!isShowAds) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" >
      <div className="relative md:flex w-full max-w-[1000px] bg-white rounded-lg shadow-2xl overflow-hidden" ref={modalRef}>
        {/* Left Section */}
        <div className="relative md:w-1/2 bg-[#e8f0ff]">
          <img
            alt="Blume Products"
            className="h-full w-full object-cover"
            src={AdsImage.url}
          />
        </div>
        {/* Right Section */}
        <div className="flex md:w-1/2 flex-col p-8 justify-center">
          <div className="mb-2 text-2xl font-bold text-[#1a2b4c]">
            {Heading}
          </div>

          {Descrption ? (
            <div className="mb-8">
              <p className="text-sm text-gray-600">{Descrption}</p>
            </div>
          ) : null}



          <a
            className="bg-action-btn2 text-white py-2 px-6 flex space-x-2 items-center text-lg
 transition-smooth mt-2 font-bold uppercase hover:scale-105 hover:-translate-y-1 hover:shadow-lg w-fit rounded-md max-lg:text-sm"
            href={Button.URL}
            onClick={() => {
              setIsOpen(false);
            }}
            rel="noopener"
            target="_blank"
          >
            {Button.Name}
          </a>
        </div>

        {/* Close Button */}
        <button
          className="absolute right-2 top-2 rounded-full p-1 text-white md:text-gray-500 hover:bg-gray-100 hover:text-gray-700"
          onClick={() => {
            setIsOpen(false);
          }}
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}


